module.exports = __webpack_public_path__ + "img/078c96480dbb7ed5dec8067cfb5d5b18.svg";